export default "__VITE_ASSET__gDLPdT_G__"